//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'
import { dexieClearDownloaded } from '@/libraries/dexie'

export default {
  name: 'Settings',
  data () {
    return {
      confirm_clear_downloads: false,
      clear_downloads_successful: false
    }
  },
  methods: {
    updateSettings (value, event) {
      const newSetting = {
        attribute: event.target.id,
        value: value
      }
      this.setSetting(newSetting)
    },
    clearDownloaded () {
      dexieClearDownloaded()
        .then(_ => {
          this.clear_downloads_successful = true
        })
    },
    ...mapActions('ui', ['setSetting', 'setTitle'])
  },
  computed: {
    ...mapState('ui', {
      getSettings: 'settings'
    }),
    settings () {
      return this.getSettings
    }
  },
  created () {
    this.setTitle('Настройки')
  }
}
